import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { OrdemProducaoComponent } from './ordem-producao.component';
import { OrdemProducaoEditComponent } from './ordem-producao-edit/ordem-producao-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [OrdemProducaoComponent, OrdemProducaoEditComponent]
})
export class OrdemProducaoModule { }
